import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/smackback/banner_fonts.webp";

function SmackFonts() {
  return (
    <section
      className="smack_fonts p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Typography & Colors</h2>
            <p>
              Colors and font letters impact your content and affect. We ensure
              the best possible representation of colors and letters in order to
              create the perfect impact on our final product. The font family
              that we have picked throughout our design is Roboto. We did
              introduce couple of variations in order to keep the font style eye
              catching for the audience. The further bifurcation of color
              pattern used in designed throughout the design are mentioned
              below.
            </p>
            <div className="smack_img">
              <StaticImage
                src="../../../images/case-studies/smackback/fonts_style.webp"
                alt="smackback TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={460}
                height={280}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className=" offset-lg-1 text-center"
          >
            <StaticImage
              src="../../../images/case-studies/smackback/fonts_img.webp"
              alt="smackback TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={505}
              height={850}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SmackFonts;
